/**
 * A class that provides utilities for controlling the throughput of events.
 * This is used to ensure scroll and resize events don't flood the postMessage channel.
 */
export class ThroughputHelper {

    // eslint-disable-next-line @typescript-eslint/ban-types
    public static debounce(func: Function, wait: number): () => void {
        let timeout: number | undefined;
        return (...args: Array<any>) => {
            clearTimeout(timeout);
            timeout = window.setTimeout(() => func(...args), wait);
        };
    }

    // eslint-disable-next-line space-before-function-paren
    public static throttle<T extends (...args: Array<any>) => void>(
        func: T,
        limit: number
    ): T {
        let lastExecution: number = 0;
        let timeout: ReturnType<typeof setTimeout> | null = null;
        return ((...args: Parameters<T>) => {
            const now: number = Date.now();

            if (now - lastExecution >= limit) {
                // Execute the function immediately if the time limit has passed
                func(...args);
                lastExecution = now;
            } else {
                // Clear the existing timeout and schedule the last execution
                if (timeout) {
                    clearTimeout(timeout);
                }

                timeout = setTimeout(() => {
                    func(...args);
                    lastExecution = Date.now();
                }, limit - (now - lastExecution));
            }
        }) as T;
    }
}
